// Control IDs for the WhatsApp page (sai's whatsapp IDs, mapped to ours by
// toTrapezium: whatsapp.* -> product.whatsapp.*). Its steps and Next come from
// sai/ids.js.
import { toTrapezium as t } from './sai/trapezium';

export const IDS = {
  replay: t('whatsapp.replay'), // plays the current thread again
};
